<template>
    <div class="animated-header-content">
        <div id="animated-header-art" v-if="art">
            <img :data-src="art" class="lazy lazy-fade" />
        </div>
        <h1 v-else-if="title" class="headline text-default-5">
            {{ title }}
        </h1>
    </div>
</template>

<script>
    import { updateLazyLoad } from '../../../common/common';

    export default {
        name: 'AnimatedHeaderContent',

        props: {
            art: String,
            title: String,
        },

        mounted() {
            if (this.art) updateLazyLoad();
        },
    };
</script>
